<div class="layout-container">
  <!-- Sidebar Navigation -->
  <app-sidenav (collapsedChange)="onSidebarCollapsedChange($event)">
  </app-sidenav>

  <!-- Main Content Area -->
  <div [ngClass]="mainContentClass()">
    <!-- Header -->
    <app-header></app-header>

    <!-- Page Content Slot -->
    <main class="page-content">
      <ng-content></ng-content>
    </main>
  </div>
</div>
